// longpress.js
import {  toRefs } from 'vue';
export default {
    mounted(el, binding) {
        const { arg } = binding;
        // console.log('arg',arg.content);
        let pressTimer = null;
        const start = (e) => {
            // console.log('e',e);
            // el.style.touchAction = 'none'; // 阻止默认行为
            if (e.touches.length === 1) {
                binding.value(false);
                pressTimer = window.setTimeout(() => {
                    e.preventDefault(); // 阻止滚动
                    // console.log('el',el);
                    let optionsTop = e.touches[0].clientY 
                    let optionsLeft = e.touches[0].clientX 
                    binding.value(arg,optionsTop, optionsLeft);
                }, 1000);
            }
        }
        // 监听touchstart事件，开始计时
        el.addEventListener("touchstart",start, { passive: false });

        
        // 监听touchmove和touchend事件，清除计时器
        el.addEventListener("touchmove", () => {
            // el.style.touchAction = 'auto'; // 恢复默认行为
            el.removeEventListener('touchstart', start);
            window.clearTimeout(pressTimer);
            pressTimer = null;
        });
    
        el.addEventListener("touchend", () => {
            el.addEventListener("touchstart",start, { passive: false });
            // el.style.touchAction = 'auto'; // 恢复默认行为
            window.clearTimeout(pressTimer);
            pressTimer = null;
        });
    }
}
  





